export default function (
  w: Window,
  d: Document,
  s: 'script',
  l: `dataLayer${string}`,
  gtmId: string,
  nonce: string,
) {
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl
    j.setAttribute('nonce', nonce)
    f?.parentNode?.insertBefore(j, f)
  })(w, d, s, l, gtmId)
}
